import React, { useEffect, useState, useRef } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table, Button, Modal, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {
    faTrashAlt,
    faFileAlt,
    faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { COLOR_APP } from '../../../constants'
import moment from "moment";
import { convertOrderStatus } from "../../../helpers/orderStatus";
import { thousandSeperate } from "../../../helpers";
import { GET_ORDERS } from "../../../graphql/order/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { DELETE_ORDER, UPDATE_ORDER } from "../../../graphql/order/mutation";
import AnimationLoading from "../../../components/AnimationLoading";

function LiveDetailCFWithUser() {
    const { history, location, match } = useReactRouter()
    const LOCAL_DATA = location.state
    const [liveOrderList, setLiveOrderList] = useState([]);
    const [liveStockList, setLiveStockList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleteOrder, setIsDeleteOrder] = useState(false);
    const [deleteData, setDeleteData] = useState();
    const [orders, setOrders] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [stockMessages, setStockMessages] = useState('');
    const [showUpdateStatus, setShowUpdateStatus] = useState(false);
    const [orderStatus, setOrderStatus] = useState("")
    const [orderToPrint, setOrderToPrint] = useState()

    const [getOrderData, { data: orderData }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
    const [deleteOrder] = useMutation(DELETE_ORDER);
    const [updateOrder] = useMutation(UPDATE_ORDER);

    let componentRef = useRef()

    useEffect(() => {
        funcGetData()
    }, [])

    const funcGetData = async () => {
        const SHOP_ID = await localStorage.getItem("SHOP");
        getOrderData({
            variables: {
                where: {
                    cfName: LOCAL_DATA?.cfName,
                    live: LOCAL_DATA?.orders[0]?.live?.id,
                    shop: SHOP_ID,
                    isDeleted: false
                },
                skip: 0,
                limit: 1000
            }
        })
    }

    useEffect(() => {
        if (orderData?.orders?.data) {
            setOrders(orderData?.orders?.data)
            let _totalPrice = 0
            let _totalAmount = 0
            let _stockMessage = ''
            for (var i = 0; i < orderData.orders.data?.length; i++) {
                _totalAmount += orderData.orders.data[i]?.amount
                _totalPrice += (orderData.orders.data[i]?.price * orderData.orders.data[i]?.amount)
                _stockMessage = _stockMessage + (_stockMessage != '' ? ', ' : '') + orderData.orders.data[i]?.liveStock?.cfMessage
            }

            let _orderToPrint = []
            const orderGroup = _.groupBy(orderData.orders.data, "liveStock.cfMessage")
            for (let [cfMessage, values] of Object.entries(orderGroup)) {
                let count = 0
                let price = 0
                let name = ""
                for (var i = 0; i < values.length; i++) {
                    count += (values[i].amount ?? 1)
                    price += (values[i].totalPrice ?? 0)
                    let value = ""
                    if (values[i]?.liveStock?.stock?.optionValues.length > 0) {
                        for (var j = 0; j < values[i].liveStock.stock.optionValues.length; j++) {
                            value = value + " " + values[i].liveStock.stock.optionValues[j]?.value
                        }
                    }

                    name = values[0]?.liveStock?.stock?.name + " " + value
                }
                _orderToPrint.push({
                    cfMessage,
                    count,
                    price,
                    name,
                })
            }
            setOrderToPrint({
                cfName: orderData.orders.data[0].cfName,
                createdAt: orderData.orders.data[0].createdAt,
                livePage: orderData.orders.data[0].live.pageName,
                liveName: orderData.orders.data[0].live.description,
                totalPrice: _totalPrice,
                totalCount: orderData?.orders?.data.length,
                orders: _orderToPrint
            })

            setTotalPrice(_totalPrice)
            setTotalAmount(_totalAmount)
            setStockMessages(_stockMessage)
        }
    }, [orderData])

    useEffect(() => {
        if (liveOrderList && liveStockList) {
            modifyData()
        }
    }, [liveOrderList, liveStockList])

    const modifyData = async () => {
        const result = _.groupBy(liveOrderList, 'liveStock.id')

        let _liveProductSummary = []
        for (let [key, value] of Object.entries(result)) {
            let _mapStock = liveStockList.filter((lStock) => lStock.id == value[0]?.liveStock?.id)
            let pushData = {
                ..._mapStock[0],
                count: value.length,
                cfMessage: value[0]?.liveStock?.cfMessage
            }
            _liveProductSummary.push(pushData)
        }
        setIsLoading(false)
    }

    const onDeleteOrder = async (order) => {
        setDeleteData(order)
        setIsDeleteOrder(true)
    }

    const _deleteOrder = async () => {
        try {
            await deleteOrder({
                variables: {
                    where: {
                        id: deleteData.id
                    }
                }
            })
            funcGetData()
            setIsDeleteOrder(false)
        } catch (error) {
            setIsDeleteOrder(false)
            console.log("error: ", error)
        }
    }

    const onUpdateOrderStatus = async () => {
        try {
            setIsLoading(true)
            let _dataForUpdate = []
            for (var i = 0; i < orders.length; i++) {
                await _dataForUpdate.push(orders[i].id);
            }

            setShowUpdateStatus(false)
            if (orderStatus && _dataForUpdate.length > 0) {
                for (var i = 0; i < _dataForUpdate.length; i++) {
                    await updateOrder({
                        variables: {
                            where: {
                                id: _dataForUpdate[i]
                            },
                            data: {
                                status: orderStatus
                            }
                        }
                    })
                }
            }
            setOrderStatus("")
            funcGetData()
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }

    return (
        <div>
            {isLoading ? <AnimationLoading /> : <div />}
            <div style={{ background: "#eee", borderRadius: 5, padding: 15, position: "relative" }}>
                <p style={{ margin: 0, fontSize: 24, fontWeight: "bold" }}>ຂໍ້ມູນການສັ່ງ</p>
                <p style={{ margin: 0 }}>ຜູ້ສັ່ງ : {LOCAL_DATA?.cfName ?? ''}</p>
                <p style={{ margin: 0 }}>ຈຳນວນການສັ່ງ : {thousandSeperate(totalAmount ?? 0)}</p>
                <p style={{ margin: 0 }}>ລວມເງິນ : {thousandSeperate(totalPrice ?? 0)}</p>
                <p style={{ margin: 0 }}>ລະຫັດສິນຄ້າທີ່ສັ່ງ : {stockMessages ?? ''}</p>
                <p style={{ margin: 0 }}>ວັນທີ : {moment(LOCAL_DATA?.createdAt).format('DD/MM/YYYY HH:mm')}</p>
                <div style={{ position: "absolute", top: 10, right: 25, background: COLOR_APP, padding: 10, borderRadius: 5 }}>
                    <p style={{ color: "#fff", fontSize: 24, margin: 0 }}>{convertOrderStatus(orders[0]?.status)} </p>
                </div>
            </div>
            <div style={{ height: 15 }} />
            <div className="row" style={{ margin: 0 }}>
                <div className="col-3" style={{ float: "left", paddingLeft: 10, paddingTop: 3, background: "green", color: "#fff" }}>
                    <FontAwesomeIcon icon={faFileAlt} />
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="btn btn-app hoverme text-white"
                        table="table-to-xls"
                        filename={"Orders-live-detail-" + (new Date().toISOString())}
                        sheet="Orders"
                        buttonText="ດາວໂຫຼດເອັກເຊວ"
                    />
                </div>
                <div style={{ width: 24 }} />
                <button className="btn btn-app hoverme col-3"
                    style={{ float: "left", background: COLOR_APP, color: "#fff" }}
                    onClick={() => setShowUpdateStatus(true)}
                >
                    <FontAwesomeIcon icon={faFileAlt} />  ອັບເດດສະຖານະ
                </button>
                {/* <div style={{ width: 24 }} />
                <ReactToPrint
                    trigger={() => <button className="btn btn-app hoverme col-3"
                        style={{ float: "left", background: COLOR_APP, color: "#fff" }}
                    >
                        <FontAwesomeIcon icon={faPrint} /> Print
                    </button>}
                    content={() => componentRef.current}
                /> */}
            </div>
            {/* <div style={{ display: 'none' }}>
                <OrderBill ref={componentRef} data={orderToPrint} />
            </div> */}
            <div style={{ height: 10 }} />
            {orders?.length > 0 && <Table responsive className="staff-table-list borderless table-hover">
                <thead style={{ background: "#F1F1F1" }}>
                    <tr>
                        <th>ລຳດັບ</th>
                        <th>ສິນຄ້າ</th>
                        <th>ລະຫັດ</th>
                        <th>ລາຄາ</th>
                        <th>ຈຳນວນ</th>
                        <th>ເປັນເງິນ</th>
                        <th>ຂໍ້ຄວາມ</th>
                        <th>ເວລາ</th>
                        <th>ຈັດການ</th>
                    </tr>
                </thead>
                <tbody>
                    {orders?.length > 0 &&
                        orders?.map((order, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                    <pre style={{ fontWeight: "bold", fontSize: 14, margin: 0 }}>
                                        {order?.liveStock?.stock?.name}
                                    </pre>
                                    {order?.liveStock?.stock?.optionValues?.length > 0 &&
                                        order?.liveStock?.stock?.optionValues.map((dd, kIndex) => <pre key={"option" + kIndex + index} style={{ margin: 0, fontSize: 12 }}>{dd.name + ':' + dd.value}</pre>)
                                    }
                                </td>
                                <td>{order?.liveStock?.cfMessage ?? ""}</td>
                                <td>{thousandSeperate(order?.price ?? 0)} {order?.liveStock?.stock?.currency ?? ""}</td>
                                <td>{thousandSeperate(order?.amount ?? 1)} {order?.liveStock?.stock?.unit ?? ""}</td>
                                <td>{thousandSeperate(order?.price * order?.amount)} {order?.liveStock?.stock?.currency ?? ""}</td>
                                <td>{order?.message ?? ""}</td>
                                <td>{moment(order?.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                                <td className="row col-12" style={{ margin: 0 }}>
                                    <button className="btn hoverme col-5" onClick={() => onDeleteOrder(order)} >
                                        <FontAwesomeIcon icon={faTrashAlt} style={{ color: "red" }} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>}

            {orders?.length > 0 && <Table id="table-to-xls" style={{ display: "none" }} responsive className="staff-table-list borderless table-hover">
                <thead style={{ background: "#F1F1F1" }}>
                    <tr>
                        <th>ລຳດັບ</th>
                        <th>ຜູ້ສັ່ງ</th>
                        <th>ສິນຄ້າ</th>
                        <th>ລະຫັດ</th>
                        <th>ລາຄາ</th>
                        <th>ຈຳນວນ</th>
                        <th>ເປັນເງິນ</th>
                        <th>ຂໍ້ຄວາມ</th>
                        <th>ເວລາ</th>
                        <th>ສະຖານະ</th>
                    </tr>
                </thead>
                <tbody>
                    {orders?.length > 0 &&
                        orders?.map((order, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{order?.cfName}</td>
                                <td>
                                    <pre style={{ fontWeight: "bold", fontSize: 14, margin: 0 }}>
                                        {order?.liveStock?.stock?.name}
                                    </pre>
                                    {order?.liveStock?.stock?.optionValues?.length > 0 &&
                                        order?.liveStock?.stock?.optionValues.map((dd, kIndex) => <pre key={"option" + kIndex + index} style={{ margin: 0, fontSize: 12 }}>{dd.name + ':' + dd.value}</pre>)
                                    }
                                </td>
                                <td>{order?.liveStock?.cfMessage ?? ""}</td>
                                <td>{thousandSeperate(order?.price ?? 0)} {order?.liveStock?.stock?.currency ?? ""}</td>
                                <td>{order?.amount ?? 1} {order?.liveStock?.stock?.unit ?? ""}</td>
                                <td>{thousandSeperate(order?.price * order?.amount)} {order?.liveStock?.stock?.currency ?? ""}</td>
                                <td>{order?.message}</td>
                                <td>{moment(order?.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                                <td>{convertOrderStatus(order?.status)}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>}

            <Modal show={isDeleteOrder} onHide={() => setIsDeleteOrder(false)}>
                <Modal.Header closeButton>
                    <div>ຢືນຢັນການລຶບ</div>
                </Modal.Header>
                <Modal.Body style={{ padding: 24, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "100%" }}>
                    <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 90, color: "orange" }} />
                    <br />
                    <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບ Order ນີ້ແທ້ບໍ່?</h5>
                </Modal.Body>
                <Modal.Footer style={{ display: "flex", flexDirection: "row", justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                        variant="outline-dark"
                        className="btn btn-app hoverme"
                        style={{ width: 150 }}
                        onClick={() => setIsDeleteOrder(false)}
                    >
                        ກັບຄືນ
                    </Button>
                    <div style={{ width: 24 }} />
                    <button
                        className="btn btn-app hoverme"
                        style={{ float: "left", background: "red", color: "#fff", width: 150 }}
                        onClick={() => _deleteOrder()}
                    >
                        ລຶບ
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showUpdateStatus} onHide={() => setShowUpdateStatus(false)} size={"lg"}>
                <Modal.Header closeButton>
                    <div>ເລືອກສະຖານະ </div>
                </Modal.Header>
                <Modal.Body style={{ padding: 0 }}>
                    <ListGroup>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("CREATED")}
                            style={orderStatus == "CREATED" ? { background: COLOR_APP, color: "#fff" } : { background: '#f9f9f9' }}
                        >ອໍເດີ້ສໍາເລັດ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("READYTOSHIP")}
                            style={orderStatus == "READYTOSHIP" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ກະກຽມຈັດສົ່ງ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("SHIPPING")}
                            style={orderStatus == "SHIPPING" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ກໍາລັງສົ່ງ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("SHIPPING_COMPLETED")}
                            style={orderStatus == "SHIPPING_COMPLETED" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ສົ່ງສໍາເລັດ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("COMPLETED")}
                            style={orderStatus == "COMPLETED" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ສໍາເລັດບໍລິການ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("CANCELLED")}
                            style={orderStatus == "CANCELLED" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ຍົກເລີກ</ListGroup.Item>
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer style={{ display: "flex", flexDirection: "row", justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                        variant="outline-dark"
                        className="btn btn-app hoverme"
                        style={{ width: 150 }}
                        onClick={() => {
                            setShowUpdateStatus(false)
                            setOrderStatus("")
                        }}
                    >
                        ກັບຄືນ
                    </Button>
                    <div style={{ width: 24 }} />
                    <button
                        className="btn btn-app hoverme"
                        style={{ float: "left", background: COLOR_APP, color: "#fff", width: 150 }}
                        onClick={() => onUpdateOrderStatus()}
                    >
                        ອັບເດດ
                    </button>
                </Modal.Footer>
            </Modal>
        </div >
    );
}

export default LiveDetailCFWithUser;